import React from 'react';

const HowToUse = () => {
   return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-5 relative text-white bg-red-600" id="Wit">
        <h1 className="text-3xl font-bold mb-8">How To Use</h1>

        {/* Timeline */}
        <div className="w-full max-w-2xl space-y-4">
            {[{
                text: 'Sign In (obvious) 🙂',
                number: 1
            }, {
                text: 'Make your 3 wishes daily. Be consistent to increase your chances of getting picked. You can change your wishes, but sticking to 3 will help your chances.',
                number: 2
            }, {
                text: 'Watch out for winner announcements every month! If this goes viral, it could become weekly or even daily!',
                number: 3
            }].map((item, index) => (
                <div key={index} className="flex items-center w-full bg-red-500 p-4 rounded-lg shadow-md">
                    {/* Circle Number */}
                    <div className="flex-shrink-0 w-14 h-14 bg-white border border-gray-300 flex items-center justify-center rounded-full">
                        <span className="text-red-500 text-xl font-bold">{item.number}</span>
                    </div>

                    {/* Description */}
                    <div className="ml-4 text-left flex-1">
                        <p className="text-base">{item.text}</p>
                    </div>
                </div>
            ))}
        </div>
    </div>
   )
};

export default HowToUse;
